// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2N2HY","calendarButtons":"ClockData_calendarButtons__1kvM3"};